import React from 'react';

function StoreCheckout({ products, setProducts, formData, setFormData }) {
    const [zoomedImage, setZoomedImage] = React.useState(null);
    
    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
      };

    const handleRemoveProduct = (productId) => {
        setProducts(products.map(p => 
            p._id === productId ? { ...p, quantity: 0 } : p
        ));
    };

    React.useEffect(() => {
        const defaults = { name: 'Magasin', phone: '+2126000000' };
        const need = {};
        if (!formData || !formData.name) need.name = defaults.name;
        if (!formData || !formData.phone) need.phone = defaults.phone;
        if (Object.keys(need).length) setFormData({ ...(formData || {}), ...need });
    }, []);
    return (
        <div className="container" style={{ marginTop: 100 }}>
            <main>


                <div className="row g-5">
                    <div className="col-md-5 col-lg-5 order-md-last" style={{ minWidth: 400 }}>
                        <h4 className="d-flex justify-content-between align-items-center mb-3" style={{ fontSize: 'calc(1rem + 8pt)', fontWeight: 700 }}>
                            <span className="text-primary">Votre Panier</span>
                            <span className="badge bg-primary rounded-pill">{products.filter(x => x.quantity > 0).length}</span>
                        </h4>
                        <div className="mb-3" style={{ maxHeight: 'calc(100vh )', overflowY: 'auto', paddingRight: 8 }}>
                            {products.filter(x => x.quantity > 0).map(product => (
                                <div key={product._id} className="card mb-2" style={{ border: '1px solid #dee2e6' }}>
                                    <div className="card-body p-3">
                                        <div className="d-flex align-items-center gap-3">
                                            <img 
                                                src={`${process.env.REACT_APP_DATA_PIC_PATH}/image.resize.php?path=${product.url_product}`}
                                                alt={product.name}
                                                onClick={() => setZoomedImage(`${process.env.REACT_APP_DATA_PIC_PATH}/${product.url_product}`)}
                                                style={{ 
                                                    width: 80, 
                                                    height: 80, 
                                                    objectFit: 'cover', 
                                                    borderRadius: 8,
                                                    cursor: 'pointer'
                                                }}
                                            />
                                            <div style={{ flex: 1 }}>
                                                <div style={{ fontSize: 'calc(1rem + 4pt)', fontWeight: 600, marginBottom: 4 }}>{product.quantity} x {product.name}</div>

                                                <div style={{ fontSize: 'calc(1rem + 4pt)', fontWeight: 700, color: '#212529', marginTop: 4 , textAlign:'right'}}>
                                                    {product.regular_price * product.quantity} MAD
                                                </div>
                                            </div>
                                            <button 
                                                onClick={() => handleRemoveProduct(product._id)}
                                                className="btn btn-outline-danger btn-sm"
                                                style={{ minWidth: 40, height: 40, padding: 0 }}
                                            >
                                                <i className="fa-solid fa-trash"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ))}

                            <div className="card" style={{ border: '2px solid #0d6efd', backgroundColor: '#f8f9fa' }}>
                                <div className="card-body p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <span style={{ fontSize: 'calc(1rem + 8pt)', fontWeight: 700 }}>Total (MAD)</span>
                                        <strong style={{ fontSize: 'calc(1rem + 8pt)', color: '#0d6efd' }}>{products.reduce((total,product)=>{
                                            return total+ (product.quantity*product.regular_price);
                                        },0)}</strong>
                                    </div>
                                </div>
                            </div>
                        </div>

                       
                    </div>
                    <div className="col-md-7 col-lg-7">
                        <form className="needs-validation" noValidate>
                            <div className="row g-3">
                                <input type="hidden" name="name" value={formData?.name || 'Magasin'} />
                                <input type="hidden" name="phone" value={formData?.phone || '+2126000000'} />
                            </div>
                            <hr className="my-4" />

                            <h2 className="mb-4" style={{ fontSize: 'calc(1rem + 12pt)', fontWeight: 700 }}>Payment</h2>

                            <div className="row g-3">
                                <div className="col-6">
                                    <div 
                                        onClick={() => setFormData({ ...formData, payment: 'cash' })}
                                        className={`card h-100 ${formData?.payment === 'cash' ? 'border-0' : 'border-secondary'}`}
                                        style={{ 
                                            cursor: 'pointer', 
                                            transition: 'all 0.3s',
                                            borderWidth: formData?.payment === 'cash' ? '3px' : '1px',
                                            backgroundColor: formData?.payment === 'cash' ? '#ec4899' : 'white'
                                        }}
                                    >
                                        <div className="card-body text-center d-flex flex-column justify-content-center align-items-center" style={{ minHeight: 180 }}>
                                            <i className="fa-solid fa-money-bill-wave" style={{ fontSize: 64, marginBottom: 16, color: formData?.payment === 'cash' ? 'white' : '#6c757d' }}></i>
                                            <h3 className="mb-0" style={{ fontWeight: 700, color: formData?.payment === 'cash' ? 'white' : '#212529' }}>Espèce</h3>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div 
                                        onClick={() => setFormData({ ...formData, payment: 'card' })}
                                        className={`card h-100 ${formData?.payment === 'card' ? 'border-0' : 'border-secondary'}`}
                                        style={{ 
                                            cursor: 'pointer', 
                                            transition: 'all 0.3s',
                                            borderWidth: formData?.payment === 'card' ? '3px' : '1px',
                                            backgroundColor: formData?.payment === 'card' ? '#ec4899' : 'white'
                                        }}
                                    >
                                        <div className="card-body text-center d-flex flex-column justify-content-center align-items-center" style={{ minHeight: 180 }}>
                                            <i className="fa-solid fa-credit-card" style={{ fontSize: 64, marginBottom: 16, color: formData?.payment === 'card' ? 'white' : '#6c757d' }}></i>
                                            <h3 className="mb-0" style={{ fontWeight: 700, color: formData?.payment === 'card' ? 'white' : '#212529' }}>Carte Bancaire</h3>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <hr className="my-4" />

                          
                        </form>
                    </div>
                </div>
            </main>

            <footer className="my-5 pt-5 text-body-secondary text-center text-small">
                <p className="mb-1">&copy; 2017–2025 Le Céladon</p>
                <ul className="list-inline">
                    <li className="list-inline-item"><a href="#">Privacy</a></li>
                    <li className="list-inline-item"><a href="#">Terms</a></li>
                    <li className="list-inline-item"><a href="#">Support</a></li>
                </ul>
            </footer>

            {zoomedImage && (
                <div 
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100vw',
                        height: '100vh',
                        backgroundColor: 'rgba(0,0,0,0.9)',
                        zIndex: 9999,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer'
                    }}
                    onClick={() => setZoomedImage(null)}
                >
                    <div style={{ position: 'relative', maxWidth: '90%', maxHeight: '90%' }}>
                        <img 
                            src={zoomedImage} 
                            alt="Preview" 
                            style={{ maxWidth: '100%', maxHeight: '90vh', objectFit: 'contain' }}
                        />
                        <button 
                            style={{
                                position: 'absolute',
                                top: -40,
                                right: 0,
                                background: 'white',
                                border: 'none',
                                borderRadius: '50%',
                                width: 40,
                                height: 40,
                                fontSize: 20,
                                cursor: 'pointer'
                            }}
                            onClick={(e) => {
                                e.stopPropagation();
                                setZoomedImage(null);
                            }}
                        >
                            ×
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}

export default StoreCheckout;